import React, { useState } from 'react';
import PortalShell from './PortalShell';
import HealthPanel from './HealthPanel';
import LogsPanel from './LogsPanel';
import OwnerAccessPanel from './OwnerAccessPanel';
import UpdatesPanel from './UpdatesPanel';
import GalleryManager from './GalleryManager';
import './Portal.css';

const TABS = [
  { id: 'health', label: 'Site health' },
  { id: 'logs', label: 'Dev logs' },
  { id: 'updates', label: 'Deploy' },
  { id: 'access', label: 'Owner access' },
  { id: 'gallery', label: 'Gallery' },
];

const COPY = {
  health: {
    title: 'Site health',
    subtitle:
      'Live checks against the production server: PHP, image processing, mail, disk, file permissions, gallery integrity and configuration. Re-runs every minute while this tab is open.',
  },
  logs: {
    title: 'Developer logs',
    subtitle:
      'Everything the site records — sign-ins, uploads, deletions, invitations, PHP errors and JavaScript errors caught in visitors’ browsers.',
  },
  updates: {
    title: 'Deploy an update',
    subtitle:
      'Drag a .zip of a new build onto the drop zone to update the front end, the backend, or both. Every deployment keeps a snapshot so it can be rolled back, and live data is never overwritten.',
  },
  access: {
    title: 'Owner access',
    subtitle: 'Invite the business owner to the portal and see who currently has an account.',
  },
  gallery: {
    title: 'Gallery',
    subtitle:
      'The same tools the owner sees. Useful for checking an upload worked, or fixing something on their behalf.',
  },
};

export default function WebmasterPortal() {
  const [tab, setTab] = useState('health');
  const copy = COPY[tab] || {};

  return (
    <PortalShell
      roleLabel="Webmaster"
      tabs={TABS}
      activeTab={tab}
      onTabChange={setTab}
      title={copy.title}
      subtitle={copy.subtitle}
    >
      {tab === 'health' && <HealthPanel />}
      {tab === 'logs' && <LogsPanel />}
      {tab === 'updates' && <UpdatesPanel />}
      {tab === 'access' && <OwnerAccessPanel />}
      {tab === 'gallery' && <GalleryManager />}
    </PortalShell>
  );
}
